export default "__VITE_ASSET__BpHF7aE0__"